import { Routes } from '@angular/router';
import { UserManagement } from './layout/user-management/user-management';
import { ReportsDashboard } from './reports-dashboard/reports-dashboard';
import { ReportManagement } from './layout/report-management/report-management';
import { AuthGuard } from '@auth0/auth0-angular';
import { Login } from './layout/login/login';
import { InvalidUser } from './layout/invalid-user/invalid-user';
import { superAdminGuard } from './shared/guards/role.guard';
import { SessionTimeout } from './layout/session-timeout/session-timeout';
import { KbLayoutComponent } from './layout/knowledge-base/_modules/kb/kb-layout/kb-layout.component';
import { Role } from './layout/role/role';

export const routes: Routes = [
    { path: 'login', component: Login },
    { path: 'session-timeout', component: SessionTimeout },
    { path: 'user/invalid', component: InvalidUser },
    { path: 'user/validate', component: Login },
    { path: '', redirectTo: 'user/validate', pathMatch: 'full' },
    { path: 'dashboard', component: ReportsDashboard, canActivate: [AuthGuard] },
    { path: 'users', component: UserManagement, canActivate: [AuthGuard, superAdminGuard] },
    { path: 'reports', component: ReportManagement, canActivate: [AuthGuard, superAdminGuard] },
    {
        path: 'kb',
        loadComponent: () =>
            import('./layout/knowledge-base/_modules/kb/kb-layout/kb-layout.component').then(m => m.KbLayoutComponent),
        canActivate: [AuthGuard]
    },
    { path: 'roles', component: Role, canActivate: [AuthGuard, superAdminGuard] },
];
